var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternallink(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#externallink_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.01.99A3.25 3.25 0 0014.625 0H3.375C2.445 0 1.65.33.99.99.33 1.65 0 2.445 0 3.375v11.25c0 .93.33 1.725.99 2.385.66.66 1.455.99 2.385.99h11.25c.93 0 1.725-.33 2.384-.99.66-.66.99-1.456.99-2.385V3.375c0-.93-.33-1.725-.99-2.385zM15 9.375c0 .328-.153.558-.457.691a.817.817 0 01-.293.059.697.697 0 01-.527-.223l-1.688-1.687-6.257 6.258a.722.722 0 01-.528.222.721.721 0 01-.527-.222l-1.196-1.196a.72.72 0 01-.222-.527.72.72 0 01.222-.527l6.258-6.258-1.687-1.688c-.242-.226-.297-.5-.164-.82.132-.305.363-.457.691-.457h5.625c.203 0 .379.074.527.223A.72.72 0 0115 3.75v5.625z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "externallink_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternallink);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "108032864609bfd81e046b1d6fd40cb5.svg";
export { MemoForwardRef as ReactComponent };